import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.css'],
    standalone: false
})
export class TextInputComponent extends BaseFormInput {
}
